import React from 'react';

import classNames from 'classnames';
import { LazyImage } from "components/Image/Index";
import * as fromProjects from 'store/Projects';

import { a } from '@react-spring/web';
import { useIntersect } from 'hooks/useIntersect';
import { useAnimateInSpring } from 'hooks/useAnimateInSpring';

interface IProps {
  animationReady: boolean;
  item: fromProjects.IContentSteppedLayoutSingleImage;
  index: number;
}

export const SingleImage: React.FC<IProps> = ({ animationReady, item, index, ...props }) => {
  const evenItem: boolean = (index % 2) === 0;
  const imageTransform = (evenItem ? 1 : -1) * 50;

  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
  });

  const animateInSpring = useAnimateInSpring(inView);

  const imageWrapperStyles = {
    opacity: animateInSpring.active,
    transform: animateInSpring.active.to(x => `translateX(calc((${x} * (-1 * ${imageTransform}px)) + ${imageTransform}px))`),
  };

  const imageContainerStyles = {
    marginLeft: item.imageOffset,
  };

  return (
    <a.div
      ref={inViewRef}
      className={classNames(
        'imageWrapper',
        { alignRight: !evenItem },
      )}
      style={imageWrapperStyles}
    >
      <a.div className='imageContainer' style={imageContainerStyles}>
        <LazyImage
          width='100%'
          heightRatio={item.heightRatio}
          src={'/assets/images/work/' + item.url}
          alt={item.alt}
          animateImageIn={true}
          animationType={'fadeIn'}
        />
      </a.div>
    </a.div>
  );
};
